import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatSelectModule } from "@angular/material/select";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { LucideAngularModule } from "lucide-angular";
import { InviteMemberDialogComponent } from "./invite-member-dialog.component";

const materialModules = [MatSelectModule];

@NgModule({
  declarations: [InviteMemberDialogComponent],
  imports: [CommonModule, TranslateModule, RouterModule, FormsModule, ReactiveFormsModule, LucideAngularModule, ...materialModules],
})
export class InviteMemberDialogModule {}
